import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';
import "./slider.scss";

class Slider extends Component {
    render() {
        return (
            <div id="slider">
                <Carousel autoPlay={true} infiniteLoop={true} useKeyboardArrows={true} dynamicHeight={true}
                          interval={7000}>
                    <div>
                        <img src={require("./slides/bauplan.jpg")} alt="Bild 1"/>
                        <div className="legend">Wohnungsbau für preisbewusste Familien</div>
                    </div>
                    <div>
                        <img src={require("./slides/wohnesszimmer.jpg")} alt="Bild 2"/>
                        <div className="legend">Handwerker und Baufirmen aus der Region</div>
                    </div>
                    <div>
                        <img src={require("./slides/bad.jpeg")} alt="Bild 3"/>
                        <div className="legend">Vermögen schaffen - Werte erhalten</div>
                    </div>
                </Carousel>
            </div>
        );
    }
};


export default Slider;








// WEBPACK FOOTER //
// ./src/content/slider/slider.js